import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function SquaresIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.5 5.75C9.5 5.61193 9.38807 5.5 9.25 5.5H5.75C5.61193 5.5 5.5 5.61193 5.5 5.75V9.25C5.5 9.38807 5.61193 9.5 5.75 9.5H9.25C9.38807 9.5 9.5 9.38807 9.5 9.25V5.75ZM11 9.25C11 10.2165 10.2165 11 9.25 11H5.75C4.78351 11 4 10.2165 4 9.25V5.75C4 4.78351 4.78351 4 5.75 4H9.25C10.2165 4 11 4.78351 11 5.75V9.25Z"
        fill="currentColor"
      />
      <path
        d="M9.5 14.75C9.5 14.6119 9.38808 14.5 9.25 14.5H5.75C5.61192 14.5 5.5 14.6119 5.5 14.75V18.25C5.5 18.3881 5.61192 18.5 5.75 18.5H9.25C9.38808 18.5 9.5 18.3881 9.5 18.25V14.75ZM11 18.25C11 19.2165 10.2165 20 9.25 20H5.75C4.78352 20 4 19.2165 4 18.25V14.75C4 13.7835 4.78352 13 5.75 13H9.25C10.2165 13 11 13.7835 11 14.75V18.25Z"
        fill="currentColor"
      />
      <path
        d="M18.5 5.75C18.5 5.61192 18.3881 5.5 18.25 5.5H14.75C14.6119 5.5 14.5 5.61192 14.5 5.75V9.25C14.5 9.38808 14.6119 9.5 14.75 9.5H18.25C18.3881 9.5 18.5 9.38808 18.5 9.25V5.75ZM20 9.25C20 10.2165 19.2165 11 18.25 11H14.75C13.7835 11 13 10.2165 13 9.25V5.75C13 4.78352 13.7835 4 14.75 4H18.25C19.2165 4 20 4.78352 20 5.75V9.25Z"
        fill="currentColor"
      />
      <path
        d="M18.5 14.75C18.5 14.6119 18.3881 14.5 18.25 14.5H14.75C14.6119 14.5 14.5 14.6119 14.5 14.75V18.25C14.5 18.3881 14.6119 18.5 14.75 18.5H18.25C18.3881 18.5 18.5 18.3881 18.5 18.25V14.75ZM20 18.25C20 19.2165 19.2165 20 18.25 20H14.75C13.7835 20 13 19.2165 13 18.25V14.75C13 13.7835 13.7835 13 14.75 13H18.25C19.2165 13 20 13.7835 20 14.75V18.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
